import {push, replace} from 'redux-first-history'

import {
  DynamicProductionTime,
  EditProviderInfoTab,
  InvoicesTab,
  Price,
  ProviderInfo,
  ProviderInfoFilterLocationState,
  SettingsTab,
} from '../types'

import {Order, OrderDetailTab, OrderId} from '../order-types'
import ROUTES from '../routes'

type RouterAction = typeof push | typeof replace

export const goToIndex = (routerAction: RouterAction = push) => routerAction(ROUTES.INDEX)

// Order pages
export const goToOrders = (routerAction: RouterAction = push) => routerAction(ROUTES.ORDERS)

export const goToOrderDetail = (
  orderId: OrderId,
  activeTab: OrderDetailTab,
  order?: Order,
  routerAction: RouterAction = push
) => routerAction(`${ROUTES.ORDER_DETAIL.replace(':id', orderId)}/${activeTab}`, {order})

// Invoices
export const goToInvoices = (activeTab: InvoicesTab, routerAction: RouterAction = push) =>
  routerAction(`${ROUTES.INVOICES}/${activeTab}`)

// Catalog table pages
export const goToProviderInfos = (
  routerAction: RouterAction = push,
  initialFilters?: ProviderInfoFilterLocationState
) => routerAction(ROUTES.PROVIDER_INFOS, {initialFilters})

export const goToCreateProviderInfo = (routerAction: RouterAction = push) =>
  routerAction(ROUTES.CREATE_PROVIDER_INFO)

export const goToEditProviderInfo = (
  providerInfos: ProviderInfo[],
  activeTab: EditProviderInfoTab,
  routerAction: RouterAction = push
) => routerAction(`${ROUTES.EDIT_PROVIDER_INFO}/${activeTab}`, {providerInfos})

export const goToPricings = (routerAction: RouterAction = push) => routerAction(ROUTES.PRICINGS)

export const goToCreatePricing = (price?: Price, routerAction: RouterAction = push) =>
  routerAction(ROUTES.CREATE_PRICING, {price})

export const goToEditPricing = (pricings: Price[], routerAction: RouterAction = push) =>
  routerAction(ROUTES.EDIT_PRICING, {pricings})

export const goToInfills = (routerAction: RouterAction = push) => routerAction(ROUTES.INFILLS)

export const goToProductionTimes = (routerAction: RouterAction = push) =>
  routerAction(ROUTES.PRODUCTION_TIMES)

export const goToDynamicProductionTimes = (routerAction: RouterAction = push) =>
  routerAction(ROUTES.DYNAMIC_PRODUCTION_TIMES)

export const goToCreateDynamicProductionTime = (routerAction: RouterAction = push) =>
  routerAction(ROUTES.CREATE_DYNAMIC_PRODUCTION_TIMES)

export const goToEditDynamicProductionTime = (
  dynamicProductionTimes: DynamicProductionTime[],
  routerAction: RouterAction = push
) => routerAction(ROUTES.EDIT_DYNAMIC_PRODUCTION_TIMES, {dynamicProductionTimes})

export const goToShippings = (routerAction: RouterAction = push) => routerAction(ROUTES.SHIPPINGS)

export const goToDiscounts = (routerAction: RouterAction = push) => routerAction(ROUTES.DISCOUNTS)

// Account pages
export const goToSettings = (activeTab: SettingsTab, routerAction: RouterAction = push) =>
  routerAction(`${ROUTES.SETTINGS}/${activeTab}`)

export const goToSignIn = (routerAction: RouterAction = push, state?: {from?: string}) =>
  routerAction(ROUTES.SIGN_IN, state)

export const goToSignInAdmin = (routerAction: RouterAction = push, state?: {from?: string}) =>
  routerAction(ROUTES.SIGN_IN_ADMIN, state)

export const goToResetPassword = (routerAction: RouterAction = push, state?: {from?: string}) =>
  routerAction(ROUTES.RESET_PASSWORD, state)
